/* eslint prefer-object-spread:0 */
import $ from 'jquery';
import { EVENTS } from '../utilities/CONSTANTS';

const getCategoriesAndFolders = () => $.get(`/api/teams/${window.teamId}/categories`)
    .done((response) => {
        window.categoriesAndFolders = response.categories;
        window.categoriesAndFoldersMap = window.categoriesAndFolders.reduce((categories, category) => {
            const mappedCategory = Object.assign({}, category);
            mappedCategory.folders = mappedCategory.folders.reduce((folders, folder) => {
                folders[folder.id] = folder;
                return folders;
            }, {});
            categories[category.id] = mappedCategory;
            return categories;
        }, {});
        window.dispatchEvent(new Event(EVENTS.CATEGORIES_LOADED));
        return window.categoriesAndFoldersMap;
    }).fail((error) => {
        console.error(error);
    });

export default getCategoriesAndFolders;
